import { useMemo } from 'react';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { CRM_OBJECT } from 'reference-resolvers-lite/constants/ReferenceTypes';
import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { STATUS_LOADING } from 'reference-resolvers-lite/Status';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import Skeleton from 'personalization-lib/components/shared/display/Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectName = ({
  objectTypeAndId
}) => {
  const resolver = useMemo(() => createStandardCachedResolver(CRM_OBJECT, objectTypeAndId.objectTypeId), [objectTypeAndId.objectTypeId]);
  const {
    reference,
    status
  } = useFetchResolver(resolver, String(objectTypeAndId.objectId));
  if (status === STATUS_LOADING) {
    return /*#__PURE__*/_jsx(Skeleton, {
      inlineSize: "10ch",
      blockSize: "1em",
      as: "span"
    });
  }
  if (!reference) {
    return null;
  }
  return /*#__PURE__*/_jsx(TruncateString, {
    children: reference.label
  });
};
export default CrmObjectName;